import { Empty, EmptyDescription, EmptyHeader } from '@monksflow/monks-ui';
import { FolderOpenIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { EmptyStateTitle } from '@/shared/ui';

interface Props {
  /** Mirrors the rail's own empty message, so the two never disagree. */
  title: string;
}

export function EmptyCollectionsPane({ title }: Props) {
  const { t } = useTranslation('knowledge');

  return (
    <div className="flex min-h-0 flex-1 flex-col rounded-lg bg-card p-xl">
      <Empty role="status" data-testid="collections-empty-pane" className="flex-1">
        <EmptyHeader>
          <FolderOpenIcon className="size-6 text-muted-foreground" aria-hidden />
          <EmptyStateTitle>{title}</EmptyStateTitle>
          <EmptyDescription>
            {t('knowledgeBases.collectionsPanel.noCollectionsYetDescription')}
          </EmptyDescription>
        </EmptyHeader>
      </Empty>
    </div>
  );
}

EmptyCollectionsPane.displayName = 'EmptyCollectionsPane';
